export const STATE_ACTIONS = {
    STATE_SEARCH: 'STATE_SEARCH',
    STATE_SEARCH_SUCCESS: 'STATE_SEARCH_SUCCESS',
    STATE_SEARCH_ERROR: 'STATE_SEARCH_ERROR',
};

export const stateSearchAction = () => ({
    type: STATE_ACTIONS.STATE_SEARCH,
});

export default {
    STATE_ACTIONS,
    stateSearchAction,
};
